import { useState } from "react";

/**
 * Which filter key the toolbar search box writes to. With a single `search.key` that's fixed;
 * with `search.fields` (a "search by" picker) it's the selected field, following any field a
 * column search has already set.
 */
export default function useSearchField(search, filters) {
    const fields = search?.fields;
    const active = filters?.filters ?? {};

    const [selected, setSelected] = useState(
        () => fields?.find((field) => active[field.key])?.key ?? fields?.[0]?.key,
    );

    if (!fields) {
        return { searchKey: search?.key, field: undefined, onFieldChange: undefined };
    }

    const field = active[selected] ? selected : (fields.find((f) => active[f.key])?.key ?? selected);

    const onFieldChange = (nextField) => {
        filters?.renameFilter(field, nextField);
        setSelected(nextField);
    };

    return { searchKey: field, field, onFieldChange };
}
